import styled from 'styled-components';
import { Button } from 'takeat-design-system-ui-kit';

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;

  .button-group {
    display: flex;
    gap: 12px;
    align-items: center;

    @media (max-width: 768px) {
      width: 100%;
      justify-content: stretch;
    }
  }
`;

export const ActionButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;

  svg {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    flex: 1;
    justify-content: center;
  }
`;

export const ActionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }

  small {
    font-size: 12px;
    color: #666;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;
